import { render, staticRenderFns } from "./FuTabs.vue?vue&type=template&id=13cb2c2e&"
import script from "./FuTabs.vue?vue&type=script&lang=js&"
export * from "./FuTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports